var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"dark":"","color":"#88acd4","fab":"","x-small":""},on:{"click":_vm.changeSelection}},'v-btn',attrs,false),on),[_c('icon',{staticClass:"fa-lg mr-1",attrs:{"icon":_vm.actionIcon}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.actionName))])])}
var staticRenderFns = []

export { render, staticRenderFns }